import { useNetworkStatus } from "../contexts/NetworkContext"; // Import hook

function NetworkStatus() {
    const { isOnline } = useNetworkStatus(); // Lấy biến isOnline từ context

    const containerStyle = {
        justifyContent: "center",
        alignItems: "center",
        color: "red",
        width: "200px",
    };

    return <div style={{ left: "calc(50% - 110px)", transform: "translateX(50%)", width: "auto", position: "absolute" }}>{!isOnline && <span style={containerStyle}>⚠️ Bạn đang offline!</span>}</div>;
}

export default NetworkStatus;
